import React, { useRef, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { useToast } from "../../core/contexts/toast";
import FiltroPI from "./filtro";
import { useAutenticação } from "../../core/contexts/auth";
import { atualizaTamanhoTabela } from "../../core/utils/funcoes";
import { sazonalidadeContexto } from "../../core/contexts/sazonalidadeContexto";
import "./index.scss";
import { useTranslation } from "react-i18next";
import { Chart as ChartJS, LineElement, CategoryScale, LinearScale, PointElement, ArcElement } from 'chart.js';
ChartJS.register(LineElement, CategoryScale, LinearScale, PointElement, ArcElement);
import { FiltroPlantaIndustrial } from "../../core/repositories/plantaIndustrialRepositorio";
import { plantaIndustrialContext } from "../../core/contexts/plantaIndustrialContexto";
import { FiltroSopFinance, RepositorioSopFinance } from "../../core/repositories/sopFinanceRepositorio";
import SopProductionGrowthChart from "./SopProductionGrowthChart";
import { SopFinanceSalesForecastChart } from "./SopFinanceSalesForecastChart";
import SopFinanceMarginChart from "./SopFinanceMarginChart";
import SopFinanceTable from "../SopFinance/SopFinanceTable";
import { ModeloSopFinance } from "../../core/models/sopFinance";

var contador: number = 0;

export default function SopFinance() {
  const { t } = useTranslation();
  const bodyRef = useRef(null);
  const { atualizarFiltroContexto, setCarregando } = sazonalidadeContexto();
  const { mostrarToast } = useToast();
  const { usuario } = useAutenticação()
  const [filtro, setFiltro] = useState(new FiltroSopFinance());
  const [permissaoEditar, setPermissaoEditar] = useState<boolean>(false)
  const [lista, setLista] = useState<ModeloSopFinance[]>([])

  const planta = plantaIndustrialContext();

  React.useEffect(() => {
    carregarDados(filtro)
    var novoFiltro = new FiltroPlantaIndustrial()
    setCarregando(true)
    novoFiltro.cod_usuario = usuario?.cod_usuario
    novoFiltro.flg_carregar_painel = true
    novoFiltro.flg_aberto = false
    planta.atualizarFiltroContexto({ ...novoFiltro })
    planta.carregarLista(novoFiltro).then(() => {
      planta.atualizarInterface();
    });

  }, []);

  React.useEffect(() => {
    // Seu código a ser executado quando a altura da página mudar para atualizar o tamanho da tabela
    const observer = new MutationObserver(atualizaTamanhoTabela);
    if (bodyRef.current) {
      observer.observe(bodyRef.current, { attributes: true, childList: true, subtree: true });
    }
    return () => {
      observer.disconnect();
    };
  });

    React.useEffect(() => {
      if (usuario && usuario.cod_usuario) {
        carregarDados(filtro, true)
      }
    }, [usuario]);

  function diferentes(filtroP: FiltroSopFinance) {
    return filtroP.dth_inicio != filtro.dth_inicio || filtroP.dth_fim != filtro.dth_fim || filtroP.cod_business_unit != filtro.cod_business_unit ||  filtroP.cod_product_family != filtro.cod_product_family || filtroP.cod_product != filtro.cod_product || filtroP.value != filtro.value
  }
  async function carregarDados(filtroP: FiltroSopFinance, forca = false) {
    try {
      if (forca || diferentes(filtroP)) {
        const _contador = contador++;
        if (_contador === contador - 1) {
          filtroP.cod_usuario = usuario?.cod_usuario
          const resposta = await new RepositorioSopFinance().getFilter(filtroP)
          console.log(resposta)
          setLista(resposta)
        }
      }
    } catch (error) {
      mostrarToast({
        titulo: t("pages.Erro!"),
        mensagem: t("pages.Aconteceu algo inesperado, por favor tente novamente mais tarde!"),
        tipo: "error",
      });
    }
  }

  function atualizarFiltro(novoFiltro: FiltroSopFinance) {
    setFiltro({ ...novoFiltro });
  }

  async function filtrarDados(novoFiltro: FiltroSopFinance) {
    setCarregando(true)
    novoFiltro.flg_aberto = false
    setFiltro({ ...novoFiltro });
    atualizarFiltroContexto({ ...novoFiltro })
    carregarDados(novoFiltro);
  }

  const [activeTab, setActiveTab] = useState<'home' | 'table'>('home');


  return (
    <div className="sazonalidade " ref={bodyRef}>
      <div className="px-2">

        <FiltroPI
          titulo={t("Finance")}
          filtro={filtro}
          atualizarFiltro={atualizarFiltro}
          permissaoEditar={permissaoEditar}
          filtrarDados={filtrarDados}
        />
      </div>




      <div className="table-100" >
        <div id="tabela">
          <div className="table-responsive">

            <div className="tabs-container card px-2  shadow-sm border-0">
              <ul className="nav nav-tabs">
                <li className="nav-item">
                  <button className={`nav-link ${activeTab === 'home' ? 'active' : ''}`} onClick={() => setActiveTab('home')}                  >
                    Home
                  </button>
                </li>
                <li className="nav-item">
                  <button className={`nav-link ${activeTab === 'table' ? 'active' : ''}`} onClick={() => setActiveTab('table')}                  >
                    Table
                  </button>
                </li>
              </ul>

              <div className="tab-content py-2 ">
                {activeTab === 'home' && (
                  <div>
                    <Row className="">
                      <Col md={6}>
                        <Card>
                          <SopFinanceSalesForecastChart filtro={filtro} home={false} />
                          {/* <SopFinanceForecastChart filtro={filtro} /> */}
                        </Card>
                      </Col>

                      <Col md={6}>
                        <Card>
                          <SopFinanceMarginChart filtro={filtro}  home={false} />
                        </Card>
                      </Col>

                      {/* <Col md={4}>
                        <Card>
                          <GrowthChart />
                        </Card>
                      </Col> */}
                    </Row>

                    <Row className=" mt-3">
                      <Col md={12}>
                        <Card>
                          <SopProductionGrowthChart filtro={filtro} />
                        </Card>
                      </Col>

                      {/* <Col md={4}>
                        <Card>
                          <SummaryTable />
                        </Card>
                      </Col> */}

                      {/* <Col md={12}>
                        <Card>
                          <FinanceForecastChart3 />
                        </Card>
                      </Col> */}
                    </Row>
                  </div>
                )}

                {activeTab === 'table' && (
                  <div>

                    <div className="table-100" >
                      <strong className=" title-card pb-1">Finance vs Forecast vs Budget Table</strong>
                      <div className="py-2">
                        <SopFinanceTable lista={lista} setLista={setLista} />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>




          </div>

        </div>
      </div>


    </div>
  );
}
